// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchBox_form__1RLCH","options":"SearchBox_options__aH3jr","moreOptions":"SearchBox_moreOptions__3IJi2","enable":"SearchBox_enable__1Na9R","vFlip":"SearchBox_vFlip__GgGB4"};